import React, { useEffect } from "react";
import { toast, ToastBar, Toaster } from "react-hot-toast";
import useUserStore, {
  fetchNotificationEvents,
  fetchUserNotificationSettings,
} from "../../../stores/user";
import NotificationNavList from "./components/nav-list";
import NotificationCategory from "./components/notification-category";
import Spinner from "../../../components/Loaders/Spinner";
import styles from "./styles.module.scss";

const NotificationSettingsPage = () => {
  const notificationEvents = useUserStore((s) => s.notificationEvents);
  const notificationEventsLoading = useUserStore(
    (s) => s.notificationEventsLoading,
  );
  const notificationEventsError = useUserStore(
    (s) => s.notificationEventsError,
  );

  useEffect(() => {
    const abortController = new AbortController();
    fetchNotificationEvents(abortController);
    fetchUserNotificationSettings(abortController);

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <div className={styles.pageContainer}>
      <div className={styles.header}>
        <h1 className={styles.pageHeading}>Notification Settings</h1>
      </div>

      {notificationEventsLoading && <Spinner size={40} />}
      {notificationEventsError && <div>{notificationEventsError}</div>}

      {!notificationEventsLoading && (
        <section className={styles.notificationSettingsContainer}>
          <section className={styles.sectionLeft}>
            {!notificationEventsLoading &&
              notificationEvents?.map((category) => (
                <NotificationCategory
                  key={category.id}
                  heading={category.name}
                  id={`notification-category-${category.id}`}
                  events={category.events}
                />
              ))}
          </section>
          <section className={styles.sectionRight}>
            <NotificationNavList
              categories={notificationEvents.map((category) => ({
                id: `notification-category-${category.id}`,
                name: category.name,
              }))}
            />
          </section>
        </section>
      )}

      <Toaster
        position="top-right"
        containerStyle={{}}
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    style={{
                      background: "none",
                      padding: "0",
                      margin: "0",
                      border: "none",
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M12.8535 12.1462C12.9 12.1927 12.9368 12.2478 12.962 12.3085C12.9871 12.3692 13.0001 12.4343 13.0001 12.5C13.0001 12.5657 12.9871 12.6307 12.962 12.6914C12.9368 12.7521 12.9 12.8073 12.8535 12.8537C12.8071 12.9002 12.7519 12.937 12.6912 12.9622C12.6305 12.9873 12.5655 13.0003 12.4998 13.0003C12.4341 13.0003 12.369 12.9873 12.3083 12.9622C12.2476 12.937 12.1925 12.9002 12.146 12.8537L7.99979 8.70685L3.85354 12.8537C3.75972 12.9475 3.63247 13.0003 3.49979 13.0003C3.36711 13.0003 3.23986 12.9475 3.14604 12.8537C3.05222 12.7599 2.99951 12.6327 2.99951 12.5C2.99951 12.3673 3.05222 12.24 3.14604 12.1462L7.29291 7.99997L3.14604 3.85372C3.05222 3.7599 2.99951 3.63265 2.99951 3.49997C2.99951 3.36729 3.05222 3.24004 3.14604 3.14622C3.23986 3.0524 3.36711 2.99969 3.49979 2.99969C3.63247 2.99969 3.75972 3.0524 3.85354 3.14622L7.99979 7.2931L12.146 3.14622C12.2399 3.0524 12.3671 2.99969 12.4998 2.99969C12.6325 2.99969 12.7597 3.0524 12.8535 3.14622C12.9474 3.24004 13.0001 3.36729 13.0001 3.49997C13.0001 3.63265 12.9474 3.7599 12.8535 3.85372L8.70666 7.99997L12.8535 12.1462Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
};

export default NotificationSettingsPage;
